<template>
  <el-dialog
      id="accountVerification-verificationMethod"
      :visible.sync="dialogVisibility"
      width="650px"
      :show-close="true"
      title="Revoke Authorization"
      class="verification-method-modal">
    <div class="steps-container">
      <warning-step
          title="Revoke this user’s account authorization?"
          description="If you do this, you’ll need to verify their account again." />

      <div class="account-verification__step__buttons-container">
        <el-button
            plain
            type="primary"
            class="account-verification__step__button account-verification__step__button-white"
            @click="exitFlow">
          Cancel
        </el-button>

        <el-button
            type="primary"
            class="account-verification__step__button"
            @click="revokeAuthorization">
          Continue
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import WarningStep from "../shared/WarningStep";
import axios from "axios";
import { createNamespacedHelpers as module } from "vuex";
const { mapActions: accountVerificationActions } = module(
  "db/account/verification"
);

const { mapGetters: accountGetters } = module("db/account");

export default {
  name: "RevokeVerificationModal",
  components: { WarningStep },
  props: {
    isDialogVisible: {
      type: Boolean,
      required: true,
      default: () => {
        return false;
      },
    },
  },
  computed: {
    ...accountGetters(["customerId"]),
    dialogVisibility: {
      get() {
        return this.isDialogVisible;
      },
      set(visible) {
        this.$emit("visibilityChanged", visible);
      },
    },
  },
  methods: {
    ...accountVerificationActions(["resetCurrentAccountVerificationState"]),
    exitFlow() {
      this.$emit("visibilityChanged", false);
    },
    revokeAuthorization() {
      axios
        .delete(`v3/customers/${this.customerId}/account_verification/revoke`)
        .then((response) => {
          this.resetCurrentAccountVerificationState();
          this.$router.go(this.$router.currentRoute);
        })
        .catch((error) => {
          console.log(
            `An error occurred while revoking authorization: ${JSON.stringify(
              error
            )}`
          );
        });
    },
  },
};
</script>

<style>
.verification-method-modal div.el-dialog__header > span.el-dialog__title {
  width: 554px;
  height: 24px;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  color: #424242;

  display: table;
  margin: 0 auto;
}

.verification-method-modal div.el-dialog__header {
  border-bottom: 1px solid #dee5ec;
}

.verification-method-modal .el-dialog__body {
  padding: 0;
}

.account-verification__step__description {
  margin-top: 8px;
  margin-bottom: 0;
}
.account-verification__step__title {
  margin: 0;
}
</style>

<style scoped>
.account-verification__step__buttons-container {
  margin-top: 40px;
}
</style>
